import FormValidation from "../../Validation/FormValidation";
import Chosen from "./Chosen";

const Select = {

    init(form) {
        this.input = 'select';
        Chosen.init(form);

        form.find('.chosen-container .chosen-single').click((evt)=>{
                const input = $(evt.currentTarget).closest('.input');
                if (!input.is('.hasCustomInput')) return;
                this.prepareCustomInput(input);
        })
    },

    prepareCustomInput(input) {
        const customInput = input.find('.input.custom');

        input.find('.chosen-results li:last-child').click((evt) => {
            input.removeClass('required').find('.chosen-container').css({display: "none"});
            customInput.addClass('required').css({display: "flex"});
        })

        customInput.find('.close').click(() => {
            input.addClass('required').find('.chosen-container').css({display: "inline-block"});
            customInput.css({display: "none"}).removeClass('required');
            input.find('select').val("");
            input.find('select').trigger('chosen:updated');
        })
    },

    bind(form) {
        form.find(this.input).on('change', (evt) => {
            FormValidation.setValid($(evt.currentTarget), this.isValid($(evt.currentTarget)));
            this.fillHiddenInputs($(evt.currentTarget));
        });
    },


    check(form) {
        let ok = true;
        form.find(this.input).each((i, el) => {
            ok = ok && this.isValid($(el));
            FormValidation.setValid($(el), ok, true);
        })
        return ok;
    },

    isValid(input) {
        const isRequired = input.closest('.input').is('.required');
        if (isRequired) return !!input.val()
        else return true;
    },

    fillHiddenInputs(el) {
        const selectName = el.attr('name');
        const selected = el.find(':selected');
        const nameInput = el.prevAll('[name="' + selectName + '_name"]');
        const iconInput = el.prevAll('[name="' + selectName + '_icon"]');

        nameInput && nameInput.val(selected.text());
        iconInput && iconInput.val(WEB_ROOT + '/templates/src/Assets/icons/png/icon.' + selected.attr('icon') + '.png');
    }
}

export default Select;
